module.exports = "<div class=\"{{type}}\">\n    <div class='preview-img'>\n        <img #img>\n    </div>   \n    <div class='preview-video'>\n        <video  #video loop controls></video>\n    </div>   \n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/preview/preview.component.html
// module id = ../../../../../src/app/components/preview/preview.component.html
// module chunks = main